import { SET_MENUS_V2 } from '../types';

/** Immutable bulkInfo update so selectors re-render (nested mutation alone does not). */
export const markMenuBulkUnsaved = () => (dispatch, getState) => {
  const {
    menu: { menu },
  } = getState();
  if (!menu?._id) return;
  dispatch({
    type: SET_MENUS_V2,
    payload: {
      bulkInfo: {
        ...(menu.bulkInfo || {}),
        isSaved: false,
      },
    },
  });
};
